import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class EstimatePeriodModule {
}
EstimatePeriodModule.ɵfac = function EstimatePeriodModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EstimatePeriodModule)(); };
EstimatePeriodModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EstimatePeriodModule });
EstimatePeriodModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, CommonModule, FeatureNeededModule] });
